<template>
	<div class="cbox">

			<div class="headbar">
				<div style="float: right">


					<el-select v-model="searchForm.school_id" v-if="teacherInfo.pmid == 1" clearable placeholder="全部学校"
						size="small" style="width:300px;margin-left:10px">
						<el-option label="全部学校" value></el-option>
						<el-option label="-" :value="1"></el-option>
						<el-option :label="item.platform" v-for="(item, idx) in SchoolList" :key="idx"
							:value="item.id"></el-option>

					</el-select>



					<el-input placeholder="关键字" v-model="searchForm.keyword" size="small" class="input-with-select"
						style="width:150px;margin-left: 10px" clearable></el-input>


					<el-button icon="el-icon-search" @click="getDataList" style="margin-left:10px" size="small"
						type="primary">搜索</el-button>


					<el-button icon="el-icon-plus" @click="addNew" style="margin-left:10px" size="small"
						type="primary">添加账号</el-button>


						<el-button icon="el-icon-upload" @click="dialogshow1 = true" style="margin-left:10px" size="small"
						type="primary">导入账号</el-button>










				</div>
				<div style="padding-top: 14px">

					<div style=" width: 200px;  margin-top:-10px;">
						<div style="width:40px;height:40px;background-color: #ebf5ff; border-radius: 50%;float: left;">
							<img :src="'/img/page.png'" style="width:60%;height:60%;margin-left: 20%;margin-top:20%" />
						</div>
						<div style="margin-left: 50px; color:#535353; font-size:20px !important">账号列表</div>
					</div>


				</div>
			</div>
			<div class="bcontent">
				<div>
					<el-table :data="tableData" row-key="id" border stripe>
						<el-table-column type="index" label="序号" width="55px" align="center"></el-table-column>
						<el-table-column label="学校" prop="platform" min-width="150" align="center"></el-table-column>
						<el-table-column label="登录账号" prop="username" min-width="150" align="center"></el-table-column>
						<el-table-column label="手机号" prop="phone" min-width="150" align="center"></el-table-column>
						<el-table-column label="可用时间段" prop="phone" min-width="150" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.login_starttime }}</span> 至
								<span>{{ scope.row.login_endtime }}</span>

							</template>

						</el-table-column>

						<el-table-column label="角色" prop="role" min-width="150" align="center">
							<template slot-scope="scope">
<!--								<span v-if="scope.row.role == 'admin'">管理员</span>
								<span v-if="scope.row.role == 'xz'">校长</span>
								<span v-if="scope.row.role == 'xzr'">系主任</span>
								<span v-if="scope.row.role == 'bzr'">班主任</span>-->
                <span style="margin-right: 5px;" v-for="(item, idx) in scope.row.sys_roles"
                      :key="idx">{{
                    item.role_name }}</span>
							</template>

						</el-table-column>

						<el-table-column label="账号类型" prop="role" min-width="150" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.isjyj">系统账号</span>
								<span v-else>子账号</span>

							</template>

						</el-table-column>

						<el-table-column label="排序号" prop="sort" width="90" align="center"></el-table-column>


						<el-table-column fixed="right" label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="editRow(scope.row)" v-if="!scope.row.isjyj || $store.state.pmid == 1"
									type="text" size="small">编辑</el-button>
								<el-button @click="deleteRow(scope.row)" v-if="!scope.row.isjyj" type="text"
									size="small">删除</el-button>
							</template>
						</el-table-column>
					</el-table>

					<div style="text-align:right;padding-top: 10px;">
						<el-pagination background @current-change="handlePageChange" :current-page="page.current_page"
							:page-size="page.per_page" :total="page.count"
							layout="total, prev, pager, next"></el-pagination>
					</div>


				</div>

			</div>
	
		<el-dialog class="cus_dialog " title="编辑账号" :visible.sync="dialogShow" :close-on-click-modal="false" width="600px"
			height="30%">
			<el-form :model="EditItem" ref="EditItem" label-width="120px">

				<el-row style="padding-top: 20px;">
					<el-col :span="20">
						<el-form-item label="所属学校">
							<el-select :disabled="teacherInfo.pmid != 1" v-model="EditItem.school_id" clearable
								placeholder="选择学校" style="width:346px;margin-left:0px">
								<el-option label="教育局平台" :value="1"></el-option>
								<el-option :label="item.platform" v-for="(item, idx) in SchoolList" :key="idx"
									:value="item.id"></el-option>

							</el-select>


						</el-form-item>

					</el-col>
					<el-col :span="20">
						<el-form-item label="账号名称">
							<el-input v-model="EditItem.username" placeholder="账号名称，登录用"></el-input>

						</el-form-item>

					</el-col>

					<el-col :span="20">
						<el-form-item label="手机号码">
							<el-input v-model="EditItem.phone" placeholder="手机号码"></el-input>
              <span>默认密码为手机号后六位，无手机号则为888888</span>

						</el-form-item>

					</el-col>

					<el-col :span="20">
						<el-form-item label="角色类型">
              <el-checkbox-group v-model="teacherAuth">
                <el-checkbox :label="item.id" v-for="(item, idx) in roles" :key="idx">
                  {{ item.role_name }}</el-checkbox>

              </el-checkbox-group>

<!--							<el-select v-model="EditItem.role" clearable placeholder="选择角色"
								style="width:346px;margin-left:0px">
								<el-option label="管理员" value="admin"></el-option>
								<el-option label="校长" value="xz"></el-option>
								<el-option label="系主任" value="xzr"></el-option>
								<el-option label="班主任" value="bzr"></el-option>


							</el-select>-->

<!--							<div style="font-size:12px;color:orangered" v-if="EditItem.role == 'admin'">管理员账号可以创建子账号</div>-->



						</el-form-item>



					</el-col>


					

					<el-col :span="20">
						<el-form-item label="排序号">
							<el-input v-model="EditItem.sort" placeholder="排序号,号越小越靠上"></el-input>

						</el-form-item>

					</el-col>
				</el-row>



			</el-form>
			<el-row>
				<el-col :span="22" style="text-align: right;">
					<el-button type="primary" @click="saveForm">保存</el-button>
				</el-col>
			</el-row>

		</el-dialog>



		<el-dialog class="cus_dialog " title="导入账号" :visible.sync="dialogshow1" :close-on-click-modal="false" width="600px"
			height="30%">
			
			<div style="line-height: 50px;display: inline-block;">
                <a href="/xls/账号导入模板.xlsx" target="_blank">下载账号导入模板</a>
            </div>
            <el-upload style="display: inline-block; margin-right: 20px;" action="" :http-request="uploadTemp"
                :on-success="uploadFiles" :show-file-list="false" name="image">
                <el-button icon="el-icon-upload" type="primary" style="margin-left:100px" size="small">选择账号导入文件</el-button>
            </el-upload>

		</el-dialog>

	</div>
</template>

<script>

export default {
	props: ["tpmid"],
	components: {



	},
	data() {
		return {
			dialogShow0: true,
			dialogShow: false,
			dialogshow1: false,
			showTj: true,
			SchoolList: [],
			searchForm: {
				school_id: "",
				class_name: "",
				keyword: "",
				status: "",
				bxcompany: ""

			},
			TargetPmid: 0,
			tableData: [],
			TreeData: [],
			teacherInfo: {},
			page: {
				count: 0,
				current_page: 1,
				per_page: 20,
				total_page: 0
			},
			EditItem: {},
			loginTimeRange: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
      roles: [],
      teacherAuth: []
		}
	},
	mounted() {
		this.searchForm.school_id = this.tpmid ? this.tpmid : 0
		this.getSchoolList()
		this.getDataList()
		this.getTeacher()


	},
	methods: {
		closeDialog() {
			this.$$parent(this, "tpmid", 0)
		},
		getSchoolList() {
			this.$http.post("/api/school_list").then(res => {
				this.SchoolList = res.data
			})
		},
		getTeacher() {
			this.$http.post("/api/get_teacher_info").then(res => {
				this.teacherInfo = res.data
			})
		},

		addNew() {
			this.EditItem = { school_id: this.teacherInfo.pmid, username: "", phone: "", role: "", sort: "" }
			console.log(this.EditItem)
			this.dialogShow = true
      this.teacherAuth = [];
      this.getRole()
		},
		getDataList() {
			let data = {
				page: this.page.current_page,
				keyword: this.searchForm.keyword,
				ktype: "username",
				school_id: this.searchForm.school_id,
				showloading: true
			}
			this.$http.post("/api/t_sch_teachers_list", data).then(res => {
				for (let item of res.data.data) {
					if (item.login_starttime) {
						item.login_starttime = item.login_starttime.split(' ')[0]
						item.login_endtime = item.login_endtime.split(' ')[0]
					}
				}
				this.tableData = res.data.data
				this.page = res.data.page
				this.tongji = res.data.tongji
			})


		},
		handlePageChange(page) {
			this.page.current_page = page;
			this.getDataList();
		},
		editRow(e) {
			// e.keyword = this.searchForm.keyword
			// e.xibu_name = this.searchForm.xibu_name
			// e.class_name = this.searchForm.class_name

			this.EditItem = e
			if (e.login_starttime) {
				this.loginTimeRange = [e.login_starttime, e.login_endtime]
			}

			this.EditItem.school_id = e.pmid
			this.dialogShow = true
      this.getRole()
      this.teacherAuth = [];
      this.teacherAuth = e.sys_roles.map(e => { return e.role_id })
		},
		saveForm(e) {

			if (this.EditItem.phone) {
				if (/^1\d{10}$/.test(this.EditItem.phone)) {

				} else {
					this.$message.error("请输入正确的手机号")
					return
				}

			}
			if (!this.EditItem.school_id) {
				this.$message.error("请选择归属学校")
				return
			}
      if (!this.EditItem.username) {
        return this.$message.error('请输入账号名称')
      }
			if (this.loginTimeRange.length > 0) {
				this.EditItem.login_starttime = this.loginTimeRange[0]
				this.EditItem.login_endtime = this.loginTimeRange[1]
			}
      if(!this.EditItem.sort){
        this.EditItem.sort = 0
      }
			this.$http.post("/api/t_sch_teachers_edit", this.EditItem).then(res => {
				this.$message.success("保存成功")
				this.dialogShow = false
        if (res.data.id) {
          this.EditItem.id = res.data.id
        }
        this.$http.post("/api/set_user_role", {
          teacher_id: this.EditItem.id,
          roleid: this.teacherAuth.join(",")
        }).then(res => {
          this.getDataList()
        })
			})



		},
		deleteRow(e) {

			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post("/api/t_sch_teachers_delete", { id: e.id }).then(res => {
					this.getDataList()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});

				})
			}).catch(() => {

			});




		},
		uploadFiles(e) {
            this.$http.post("/api/import_teacher_xls", {
                url: e.src
            }).then(res => {

                this.getDataList()
                this.$message.success("导入成功")
                if (res.data.msg.length > 0) {
                    let html = ''
                    for (let msg of res.data.msg) {
                        html += "<div style='font-size:12px'>" +msg+"</div>"
                    }
                    this.$alert(html, '未导入数据', {
                        dangerouslyUseHTMLString: true
                    });
                }
                this.dialogshow1 = false


            })
        },
    getRole() {
      this.$http.post("/api/sys_role_list", { pagesize: 100}).then(res => {
        this.roles = res.data.data
      })
    },


	}
}
</script>
<style scoped></style>
